(function () {
    'use strict';

    angular.module('app').directive('fodbzDropdown', ComboboxDirective);

    ComboboxDirective.$inject = [];
    function ComboboxDirective() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                fodbzModel: '=',
                fodbzFieldConst: '@',
                organisationTypes: '=',
                fodbzInit: '@'
            },
            template: `
            <select aria-describedby="{{fodbzFieldConst}}Error"
                    class="form-control"
                    ng-model="fodbzModel"
                    id="{{fodbzFieldConst}}"
                    name="{{fodbzFieldConst}}"
                    ng-options="item.Key as item.Value for item in organisationTypes"
                    type="number">
                    <option ng-if="fodbzInit" value="" class="combo-placeholder">{{fodbzInit}}</option>
            </select>`,
        };
    }
})();